export class RowFormat {
  solidBottomBorder: boolean = false;
}
